// Any component that wants auth state näide
// import React from 'react'
// import { useAuth } from './use-auth.js'

// function Navbar (props) {
//   // Get auth state and re-render anytime it changes
//   const auth = useAuth()

//   return (
//     <NavbarContainer>
//       <Logo />
//       <Menu>
//         <Link to='/about'>About</Link>
//         <Link to='/contact'>Contact</Link>
//         {auth.user ? (
//           <Fragment>
//             <Link to='/account'>Account ({auth.user.email})</Link>
//             <Button onClick={() => auth.signout()}>Signout</Button>
//           </Fragment>
//         ) : (
//           <Link to='/signin'>Signin</Link>
//         )}
//       </Menu>
//     </NavbarContainer>
//   )
// }

// Hook (use-auth.js)
import React, { useState, useEffect, useContext, createContext } from 'react'
import {
  Stitch,
  RemoteMongoClient,
  UserPasswordCredential,
  UserPasswordAuthProviderClient,
  StitchClientError,
  registerWithEmail,
  emailPassword
  //AnonymousCredential,
} from 'mongodb-stitch-browser-sdk'

// Add your Firebase credentials
const APP_ID_TUTOR = process.env.REACT_APP_MANTIME_ID
//const email = process.env.REACT_APP_EMAIL
//const password = process.env.REACT_APP_PW

export const client = Stitch.initializeDefaultAppClient(APP_ID_TUTOR)
export const mongodb = client.getServiceClient(
  RemoteMongoClient.factory,
  'mongodb-atlas'
)

const app = Stitch.defaultAppClient

const authContext = createContext()
const emailPassClient = client.auth.getProviderClient(
  UserPasswordAuthProviderClient.factory
)
//et ei v]taks cashist andmeid
//StitchClientError.defaultAppClient.auth.addAuthListener(auth =>{this.setState({isAuth:auth.isLoggedIn})})
// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvideAuth ({ children }) {
  const auth = useProvideAuth()

  return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = () => {
  return useContext(authContext)
}

// Provider hook that creates auth object and handles state
function useProvideAuth () {
  // Wrap any Firebase methods we want to use making sure ...
  // ... to save the user to state.

  const [user, setUser] = useState('')

  const signin = async (email, password) => {
    const credential = new UserPasswordCredential(email, password)
    await app.auth.loginWithCredential(credential)
    setUser(user => app.auth.currentUser.profile.data.email)
    Stitch.defaultAppClient.auth.addAuthListener(auth => {
      setUser({ isAuth: auth.isLoggedIn })
      console.log('autgoriseerimine', auth.isLoggedIn)
    })
    return user
  }

  const signup = async (email, password) => {
    let request = emailPassClient.registerWithEmail(email, password)

    request
      .then(result => {
        console.log(result)
        if (result) {
          console.log('isauth', result)

          //this.setState({ isAuth: true });
        }
      })
      .catch(err => {
        console.log(err)
        //this.setState({ isAuth: false });
      })

    //return await app.auth.emailPassword.registerUser(email, password)
  }

  const signout = () => {
    return setUser(false)
    // return mongodb.logout()

    // .then(() => {
    //   setUser(false)
    // })
  }

  const sendPasswordResetEmail = email => {
    return app
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        return true
      })
  }

  const confirmPasswordReset = (code, password) => {
    return app
      .auth()
      .confirmPasswordReset(code, password)
      .then(() => {
        return true
      })
  }
  useEffect(() => {
    if (user) {
      setUser(user)
    } else {
      setUser('')
    }

    // Cleanup subscription on unmount
    return () => user
  }, [])
  // Subscribe to user on mount
  // Because this sets state in the callback it will cause any ...
  // ... component that utilizes this hook to re-render with the ...
  // ... latest auth object.
  // useEffect(() => {
  //   const unsubscribe = firebase.auth().onAuthStateChanged(user => {
  //     if (user) {
  //       setUser(user)
  //     } else {
  //       setUser(false)
  //     }
  //   })

  //   // Cleanup subscription on unmount
  //   return () => unsubscribe()
  // }, [])

  // Return the user object and auth methods
  return {
    user,
    signin,
    signup,
    signout,
    sendPasswordResetEmail,
    confirmPasswordReset
  }
}
